export const PlanIds = {
  hack: process.env.REACT_APP_PLAN_ID_HACK || "667d12f8a5f239abc0f8db27",
  hackq: process.env.REACT_APP_PLAN_ID_HACKQ || "69df1ecab1bbd1326c6a4aa5",
  hacks: process.env.REACT_APP_PLAN_ID_HACKS || "69e77b3a64299ffc14ea8550",
  launch: process.env.REACT_APP_PLAN_ID_LAUNCH || "667d1ab8a5f239abc0f8db28",
  launchq: process.env.REACT_APP_PLAN_ID_LAUNCHQ || "69df1ecab1bbd1326c6a4aa6",
  launchs: process.env.REACT_APP_PLAN_ID_LAUNCHS || "69e77b7264299ffc14ea8551",
  scale: process.env.REACT_APP_PLAN_ID_SCALE || "65cdd451f6bf8bf2e8ed1851",
  scaleq: process.env.REACT_APP_PLAN_ID_SCALEQ || "69e77c6964299ffc14ea8552",
  scales: process.env.REACT_APP_PLAN_ID_SCALES || "69e77cbd64299ffc14ea8553",
  build: process.env.REACT_APP_PLAN_ID_BUILD || "687630cca4adf058141c5fdd",
  buildq: process.env.REACT_APP_PLAN_ID_BUILDQ || "69e77dab64299ffc14ea8554",
  builds: process.env.REACT_APP_PLAN_ID_BUILDS || "69df1ecab1bbd1326c6a4aa7",
  grow: process.env.REACT_APP_PLAN_ID_GROW || "6876320ba4adf058141c5fdf",
  growq: process.env.REACT_APP_PLAN_ID_GROWQ || "69e789e864299ffc14ea8556",
  grows: process.env.REACT_APP_PLAN_ID_GROWS || "69e78a6a64299ffc14ea8557",
  accelerate: process.env.REACT_APP_PLAN_ID_ACCELERATE || "68763487a4adf058141c5fe1",
  accelerateq: process.env.REACT_APP_PLAN_ID_ACCELERATEQ || "69e78b5264299ffc14ea8558",
  accelerates: process.env.REACT_APP_PLAN_ID_ACCELERATES || "69e78b6f64299ffc14ea8559",
};
